export default __webpack_public_path__ + "static/media/ic_svg_info.8e985de8.svg";